import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent {
  private auth = inject(AuthService);
  private router = inject(Router);

  email = '';
  isSubmitting = false;
  errorMessage = '';

  onSubmit(): void {
    if (this.isSubmitting) {
      return;
    }

    this.errorMessage = '';
    this.isSubmitting = true;

    this.auth.requestPasswordReset(this.email).subscribe({
      next: (result) => {
        this.isSubmitting = false;

        if (!result.success) {
          this.errorMessage = result.message ?? 'Unable to continue. Please try again.';
          return;
        }

        this.router.navigate(['/reset-password'], {
          queryParams: { email: this.email.trim().toLowerCase() }
        });
      },
      error: () => {
        this.isSubmitting = false;
        this.errorMessage = 'Unable to continue. Please try again.';
      }
    });
  }

  backToLogin(): void {
    this.router.navigate(['/login']);
  }
}
